import { BaseMapper } from 'src/data/common/BaseMapper'

import { CustomerLoyaltyAPI, CustomerLoyaltyModel, CustomerLoyaltyTierAPI, CustomerLoyaltyTierModel } from './type'

export class CustomerLoyaltyMapper extends BaseMapper {
    apiMapper = (response: CustomerLoyaltyAPI): CustomerLoyaltyModel => ({
        amount_frames_to_upgrade: response.amount_frames_to_upgrade,
        amount_money_to_upgrade: response.amount_money_to_upgrade,
        current_tier: new CustomerLoyaltyTierMapper().getMappedObject({
            data: response.current_tier,
            from: 'api'
        }),
        next_tier: new CustomerLoyaltyTierMapper().getMappedObject({
            data: response.next_tier,
            from: 'api'
        }),
    })

    public static defaultValue: CustomerLoyaltyModel = {
        amount_frames_to_upgrade: 0,
        amount_money_to_upgrade: 0,
        current_tier: null,
        next_tier: null
    }
}

export class CustomerLoyaltyTierMapper extends BaseMapper {
  apiMapper = (currentTier: CustomerLoyaltyTierAPI): CustomerLoyaltyTierModel => ({
    amount_spent_to_reach: currentTier.amount_spent_to_reach,
    frames_required: currentTier.frames_required,
    id: currentTier.id,
    state: currentTier.state,
    tier_name: currentTier.tier_name,
    tier_name_fr: currentTier.tier_name_fr
  })

  public static defaultValue: CustomerLoyaltyTierModel = {
    amount_spent_to_reach: 0,
    frames_required: 0,
    id: 0,
    state: '',
    tier_name: '',
    tier_name_fr: ''
  }
}
